export const TEST_ID = 'applicationsIcon';
